import { P, Table, Td, Tr } from '@dnb/eufemia';
import { Field } from '@dnb/eufemia/extensions/forms';
import styled from '@emotion/styled';
import { useMemo } from 'react';

interface Props {
  scopeEntitlementNames: string[];
}

export default function TogglableScopeList({ scopeEntitlementNames: scopeEntitlementNames }: Props) {
  const scopesSortedByName = useMemo(() => {
    return scopeEntitlementNames.toSorted((a, b) => a.localeCompare(b));
  }, [scopeEntitlementNames]);

  if (scopeEntitlementNames.length === 0) {
    return (
      <P space="small">
        <i>No scopes available for this API.</i>
      </P>
    );
  }

  return (
    <Table border bottom="x-small" outline>
      <tbody>
        {scopesSortedByName.map((scopeName) => (
          <Tr key={scopeName} noWrap>
            <Td>
              <Field.Toggle
                label={<BreakableText>{scopeName}</BreakableText>}
                path={`/selectedScopes/${scopeName}`}
                valueOff={false}
                valueOn
                variant="checkbox"
              />
            </Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
}

const BreakableText = styled.span`
  word-break: break-word;
  white-space: normal;
`;
